import type { ReactNode } from 'react';

import { cn } from '@/utils/cls';

interface StatCardProps {
  label: ReactNode;
  value: ReactNode;
  icon?: ReactNode;
  /** Optional delta text + tone — e.g. "+12% vs yesterday" in success green. */
  delta?: ReactNode;
  deltaTone?: 'success' | 'warn' | 'danger' | 'neutral';
  className?: string;
}

const TONE = {
  success: 'text-success',
  warn: 'text-warn',
  danger: 'text-danger',
  neutral: 'text-ink-soft',
} as const;

/** Used on the dashboard + report headers — large number + label + optional icon. */
export function StatCard({ label, value, icon, delta, deltaTone = 'neutral', className }: StatCardProps) {
  return (
    <div className={cn('card p-4 flex items-start gap-4', className)}>
      {icon && (
        <div className="h-11 w-11 flex-shrink-0 rounded-xl bg-brand-500/10 text-brand-600 inline-flex items-center justify-center">
          {icon}
        </div>
      )}
      <div className="min-w-0 flex-1">
        <div className="stat-label">{label}</div>
        <div className="stat-value mt-1 truncate">{value}</div>
        {delta && (
          <div className={cn('text-xs mt-1', TONE[deltaTone])}>{delta}</div>
        )}
      </div>
    </div>
  );
}
